export class CandidateAdditionalDetails {
    candidateId: any = null;
    salary: any = null;
    sponsorships: any = [];
    sponsorshipsNote: any = null;
    willingToRelocate: any = null;
    relocationNote: any = null;
    additionalInformation: any = null;
    workLocations: any = null;
}